const Colours = {
  White:     '#fff',
  Black:     '#000',
  Primary:   '#5200CC',
  Secondary: '#FF6699',
};

export default Colours;
